import React from 'react';
import { rbacService } from '../../../services/RBACService';

interface RBACWrapperProps {
  children: React.ReactNode;
  userRole: 'client' | 'vendor' | 'admin';
  requiredPermission?: string;
  requiredAction?: string;
  fallback?: React.ReactNode;
}

export const RBACWrapper: React.FC<RBACWrapperProps> = ({
  children,
  userRole,
  requiredPermission,
  requiredAction,
  fallback = null
}) => {
  const hasAccess = () => {
    if (!requiredPermission || !requiredAction) return true;
    
    const userId = 'current-user';
    return rbacService.hasPermission(userId, requiredPermission, requiredAction as any);
  };

  const filterSensitiveData = (data: any) => {
    if (userRole === 'client') {
      const filtered = { ...data };
      delete filtered.internalNotes;
      delete filtered.estimatedCost;
      delete filtered.actualCost;
      delete filtered.vendorComments;
      delete filtered.profitMargin;
      return filtered;
    }
    return data;
  };

  if (!hasAccess()) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export const useRBACFilter = (userRole: 'client' | 'vendor' | 'admin') => {
  return {
    filterData: (data: any) => {
      if (userRole === 'client') {
        const filtered = { ...data };
        delete filtered.internalNotes;
        delete filtered.estimatedCost;
        delete filtered.actualCost;
        delete filtered.vendorComments;
        delete filtered.profitMargin;
        return filtered;
      }
      return data;
    },
    canViewField: (fieldName: string) => {
      const restrictedFields = ['internalNotes', 'estimatedCost', 'actualCost', 'vendorComments', 'profitMargin'];
      return userRole !== 'client' || !restrictedFields.includes(fieldName);
    }
  };
};
